import URI from 'urijs';
import getAnswerService from "../util/getAnswerService";
import itemCart from '../util/itemCart';
import { $ } from "../util/jq";
import changePageClass from './_changePageClass';
import initAnswerMods from './_initAnswerMods';
import initProducts from './_initProducts';
import initSummary from "./_initSummary";

const ignite = window.ignite;

class SummaryPage {

  /**
   * @const bottomLineProductMap: Ignite Product ID -> BottomLine ID
   */
  constructor() {
    this.customerAffiliate = '01';
    this.applicationLinkTarget = '';
    this.contactInformation = null;
    this.cartCountSelector = '#cartButton .number';
    this.igniteToBottomLineIdMap = {
      '15000': 'checking_world_checking', //World Checking
      '15001': 'checking_preferred_interest', //Preferred Interest
      '15002': 'checking_mychoice_plus', //MaxMoney Prospect
      '15066': 'checking_mychoice_plus', //MaxMoney Customer
      '15003': 'checking_mychoice', //MyChoice Checking
      '15004': 'checking', //Free Checking
      '15005': 'savings', //SaveUp Savings
      '15006': 'savings_mm', //Online Money Market
      '15008': 'cd_long_term', //CD
      '15010': 'cd_traditional_ira', //Traditional IRA
      '15011': 'cd_roth_ira', //Roth IRA
      '15013': 'checking_hsa', //Health Savings Account
      '15016': 'checking_prepaid_card', //Outlook Prepaid Card
      '15030': 'cc_only_card', //The Only Card
      '15036': 'personal_loan', //Personal Loan
      '15037': 'checking_free_small_business', //Free Small Business
      '15039': 'savings_mm', //Business Money Market
    };
    this.affiliatesToMarketIdMap = {
      'central':          '01',
      'centralbankac':    '24',
      'centralbankstl':   '20',
      'boonecounty':      '16',
      'branson':          '10',
      'bankcentral':      '45',
      'bankCentral':      '45',
      'jefferson':        '02',
      'lakeozarks':       '11',
      'midwest':          '14',
      'moberly':          '22',
      'oklahoma':         '29',
      'ozarks':           '27',
      'sedalia':          '15',
      'warrensburg':      '39',
      '01':               '01',
      '24':               '24',
      '20':               '20',
      '16':               '16',
      '11':               '11',
      '10':               '10',
      '02':               '02',
      '14':               '14',
      '22':               '22',
      '29':               '29',
      '27':               '27',
      '15':               '15',
      '39':               '39',
      '45':               '45',
    };
    this.affiliatesToHSALink = {
      'central':          'CNB-C75002',
      '01':               'CNB-C75002',
      'centralbankac':    'AUD-C71305',
      '24':               'AUD-C71305',
      'centralbankstl':   'STB-C19515',
      '20':               'STB-C19515',
      'boonecounty':      'BOB-C89015',
      '16':               'BOB-C89015',
      'branson':          'BRA-C42961',
      '10':               'BRA-C42961',
      'jefferson':        'JBM-J22350',
      '02':               'JBM-J22350',
      'bankcentral':      'CNB-C75002',
      '45':               'CNB-C75002',
      'lakeozarks':       'LAK-C61708',
      '11':               'LAK-C61708',
      'midwest':          'MIW-C65233',
      '14':               'MIW-C65233',
      'moberly':          'MOB-C16570',
      '22':               'MOB-C16570',
      'oklahoma':         'OKA-C78522',
      '29':               'OKA-C78522',
      'ozarks':           'OZK-C02794',
      '27':               'OZK-C02794',
      'sedalia':          'SED-C59510',
      '15':               'SED-C59510',
      'warrensburg':      'WAR-C04936',
      '39':               'WAR-C04936',
    };
  }

  async getCustomerAffiliateValue() {
    const that = this;
    const answerService = await getAnswerService();
    const answer = await answerService.getAnswer('customerAffiliate');
    that.customerAffiliate = answer && answer.value && answer.value.length ? answer.value[0] : '01';
  }

  setupCart(){
    const that = this;
    $('body').addClass("cart-hidden");

    const cartUpdated = (data) => {
      //update the cart count
      if(data.hasOwnProperty('count') && data.count >= 0){
        $(that.cartCountSelector).removeClass('bounce');
        setTimeout( function() { $(that.cartCountSelector).html(data.count).addClass('bounce'); }, 100 );
      }
      //if a product is removed/added to the cart, we need to click the "makeReferral" button to trigger mm-web snippet change
      if(data.hasOwnProperty('transactionType') && data.hasOwnProperty('element')){
        const cartProductIndex = data.element.attr('shelf-item-index');
        const $shelfProductCell = $(`#productShelf .productCell[shelf-item-index=${cartProductIndex}]`);
        if(data.transactionType === 'remove') {
          $shelfProductCell.find('.makeReferralCheckbox:checked').click();
        }else if(data.transactionType === "add") {
          $shelfProductCell.find('.makeReferralCheckbox:not(:checked)').click();
          submitGTag('DC-8242699/comme0/2019_00-+standard');
        }
      }
      // if number of cart items equal number of products in shelf display remove button
      const $productCells = $('#productShelf .displayGroupProducts > .productCell').length;
      const $removeBtn = $('.addRemoveContainer .btn.remove');
      const $addBtn = $('.addRemoveContainer .btn.add');
      if (data.count === $productCells) {
        $removeBtn.addClass('visible');
        $addBtn.addClass('hide');
      } else {
        $removeBtn.removeClass('visible');
        $addBtn.removeClass('hide');
      }

      //re-order products in bottomLine section so that checking is first
      $('#cart-section-bottomLine > .productCell').each(function() {
        if($(this).attr('data-product-category') === 'consumer-checking'){
          $(this).insertAfter('#cart-section-bottomLine .cart-info');
        }
      });

      that._updateURIToBottomLine();
    };

    this.cart = itemCart({
      shelfId:              "productShelf",
      cartId:               "productCart",
      itemsClass:           "productCell",
      addItemClass:         "add-to-cart",
      removeItemClass:      "remove-from-cart",
      clearCartBtnId:       "clear-cart",
      onUpdateFunc:         cartUpdated,
      cartMap: {
        "cartType_bottomLine":    "cart-section-bottomLine",
        "cartType_apply":         "cart-section-apply",
        "cartType_assistance":    "cart-section-other-products",
        "cartType_learnMore":     "cart-section-other-products"
      }
    });

    this._toggleCart();
    this._addAllToCart();
    this._setupApplyButtons();
  }

  initAnswerSection(){
    //answer section toggle
    $('.online-summary--answers .answer-section .section-header').click(function() {
      $(this).parents('.answer-section.content-section').toggleClass('active');
    }) ;
  }

  initInformationModals(){
    /* add product summary to modal */
    $('.more-info').on('click', function() {
      var moreInfo = $(this).parents('.product-footer').siblings('.product-body').children('.show-more');
      var productClass = $(this).parents('.productCell').attr('id')
      $('.summary-modal').addClass(productClass);
      $('#exampleModal .modal-body').empty().append( $( moreInfo ).html() );
      $('#productTitle').empty().append(
        $(this).parents('.product-footer').siblings('.product-header').children().children('.checkText').html()
      );
    });
  }

  makeCartButtonSticky(){
    /* sticky apply now button */
    $(window).scroll(function() {
      const checked = $('.displayGroupProducts .item-active').length;
      const scroll = $(window).scrollTop();
      if ( scroll >= 0.25 * $(window).height() && checked >= 1 ) {
        $('.apply-now').addClass('sticky');
      } else {
        $('.apply-now').removeClass('sticky');
      }
    });
  }

  modalSuccessCallback() {
    const emailResultsSent = window.ignite.emailResultsSent;
    const textResultsSent = window.ignite.textResultsSent;
    const $successModal = $('.successModal');
    const $successMessage = $('.successMessage')
    window.ignite.emailResultsSent = () => {
      emailResultsSent();
      $successModal.addClass('visible');
      $successMessage.children('.fa-envelope-o').addClass('animated tada');
    };
    window.ignite.textResultsSent = () => {
      textResultsSent();
      $successModal.addClass('visible');
      $successMessage.children('.fa-envelope-o').addClass('animated tada');
    };
  }

  closeSuccessCallback() {
    const successModal = $('.successModal');
    $('.successModal .successMessage .fa-times').on("click", function(){
      successModal.removeClass('visible');
    });
  }

  _toggleCart() {
    $('#close-cart').click(function() {
      $('body').addClass("cart-hidden");
    });
    $('#cartButton').click(function() {
      $('body').removeClass("cart-hidden");
    });
  }

  _addAllToCart() {
    const $productCells = $('#productShelf .displayGroupProducts > .productCell > .product-footer');

    $('#addAllCart').on('click', function() {
      $productCells.each(function() {
        const $cell = $(this);
        if($cell.find('.makeReferralCheckbox:not(:checked)').length){
          $cell.find('.makeReferralCheckbox').click(); //trigger mm-web snippet
          $cell.find('.add-to-cart').click(); //trigger jquery-cart change
        }
      });
    });

    $('#removeAllCart').on('click', function() {
      $productCells.each(function() {
        const $cell = $(this);
        if($cell.find('.makeReferralCheckbox:checked').length){
          $cell.find('.makeReferralCheckbox').click();
          $cell.find('.remove-from-cart').click();
        }
      });
    });
  }

  _setupApplyButtons() {
    const that = this;

    window.ignite.preContactSubmitted = (lead) => {
      that.contactInformation = lead;
      that._updateURIToBottomLine();
      that._openApplication();
    }

    $(document).on('click', '#sendToBottomLine, #sendToBottomLineBusiness, #productCart .product-cta-button', (e) => {
      e.preventDefault();
      that.applicationLinkTarget = $(e.target);
      submitGTag('DC-8242699/comme0/2019_00a+standard');
      window.ignite.showContactForm();
    });

    $(document).on('click', '#contactForm .btn', () => {
      submitGTag('DC-8242699/comme0/2019_00b+standard');
    });
  }

  _openApplication() {
    const href = this.applicationLinkTarget.attr('href') || this.applicationLinkTarget.parents('a').attr('href');
    window.open(href, '_blank');
  }

  _updateURIToBottomLine(){
    //map bottom line products in the cart to their respective ID, send to bottomLine
    const productList = [];
    $('#cart-section-bottomLine').find('> .productCell').each(function () {
      const $product = $(this);
      productList.push($($product).data('product-id'));
    });

    const bottomLineIds = productList.map(igniteProductId => this.igniteToBottomLineIdMap[igniteProductId]);
    const marketId = this.affiliatesToMarketIdMap.hasOwnProperty(this.customerAffiliate) ? this.affiliatesToMarketIdMap[this.customerAffiliate] : this.affiliatesToMarketIdMap.central;
    const environment = ( window.ignite.getRunMode().toLowerCase() === 'production' ) ? 'production' : 'development';
    const uri = URI('/static/bottomLine')
      .addSearch('market', marketId)
      .addSearch('prod', bottomLineIds.join())
      .addSearch('environment', environment);
    //Add Contact Information
    if(this.contactInformation){
      if(this.contactInformation.hasOwnProperty('firstName')){
        uri.addSearch('firstName', this.contactInformation.firstName);
      }
      if(this.contactInformation.hasOwnProperty('lastName')){
        uri.addSearch('lastName', this.contactInformation.lastName);
      }
      if(this.contactInformation.hasOwnProperty('email')){
        uri.addSearch('email', this.contactInformation.email);
      }
      if(this.contactInformation.hasOwnProperty('phone')){
        uri.addSearch('phone', this.contactInformation.phone);
      }
    }
    uri.normalizeSearch();
    const finalURI = uri.toString().replace('?', '#');
    console.log('Updating URI to BottomLine button: ', finalURI);
    $('#sendToBottomLine').attr('href', finalURI);
  }

  updateHSALink(){
    const $hrefElem = $('.hsa_applyLink');
    const secValue = this.affiliatesToHSALink[this.customerAffiliate] || this.affiliatesToHSALink[0];
    if($hrefElem && $hrefElem.length && secValue) {
      const uri = URI($hrefElem.attr('href'))
        .addSearch('sec', secValue);
      $hrefElem.attr('href', uri.normalizeSearch().toString());
    }
  }

  setupPromotions(){
    const promoStartTime = new Date('2025-06-01').setHours(0,0,0,0);
    const promoExpiryTime = new Date('2025-06-30').setHours(0,0,0,0);
    const nowTime = new Date().setHours(0,0,0,0);

    const promoIsActive = () => {
      const overrideParam = window.location.search === '?promoTest';
      if (promoStartTime && promoExpiryTime) {
        return ((promoStartTime < nowTime) && (nowTime < promoExpiryTime)) || overrideParam;
      }
      return false;
    }

    const $promoModal = $('#promotionModal');
    const $promoButton = $('#promotionButton');
    if($promoModal.length && promoIsActive()) {
      $promoButton.show();
      $promoButton.click(function () {
        $promoModal.modal();
        $promoButton.removeClass('pulse');
      });
    }else{
      $promoButton.hide();
    }
  }

  submitSummaryPageView() {
    submitGTag('DC-8242699/comme0/2019_009+standard');
  }

  async render() {
    changePageClass('summary');
    initSummary();
    initProducts();
    initAnswerMods();
    await this.getCustomerAffiliateValue();
    this.setupCart();
    this.makeCartButtonSticky();
    this.initAnswerSection();
    this.initInformationModals();
    this.modalSuccessCallback();
    this.closeSuccessCallback();
    this.updateHSALink();

    this.setupPromotions();
    this.submitSummaryPageView();
  }
}

const submitGTag = (sendTo) => {
  if (typeof gtag === 'function') {
    gtag('event', 'conversion', {
      'allow_custom_scripts': true,
      'send_to': sendTo
    });
  }
};

export default function summaryPage() {
   (new SummaryPage()).render();
}



// WEBPACK FOOTER //
// ./src/main/js/pages/summaryPage.js